"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.assist.attachKnowledge': '附加知识：',
    'ai.assist.knowledgeFound': '找到相关知识',
    'ai.assist.relevantKnowledgeFound': '对话后找到相关知识',
    'ai.assist.attachmentIds': '附件ID',
};
